import { Injectable } from '@angular/core';
import { WeatherDecisionDetails, WeatherLookupResult } from '../models/weather-bonus.models';

@Injectable({
  providedIn: 'root'
})
export class WeatherDecisionService {
  private readonly rainyWeatherCodes = [51, 53, 55, 61, 63, 65, 66, 67, 80, 81, 82];

  evaluate(lookup: WeatherLookupResult): WeatherDecisionDetails {
    const weatherCode = Number(lookup.weatherCode);
    const hasRainAmount = (lookup.precipitationMm || 0) > 0;
    const hasRainCode = this.rainyWeatherCodes.indexOf(weatherCode) !== -1;
    const isRaining = hasRainAmount || hasRainCode;
    const windowMinutes = lookup.observationWindowMinutes || 60;

    return {
      isRaining,
      decisionRule: 'same_day_ocr_time_lookback_60_min_precipitation_gt_0_or_rain_code',
      decisionReason: isRaining
        ? `Rain detected within ${windowMinutes} minutes before the OCR purchase time`
        : `No rain detected within ${windowMinutes} minutes before the OCR purchase time`,
      bonusPoints: 0
    };
  }
}
